// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* @description NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export var CaseContactInformationType;
(function (CaseContactInformationType) {
    CaseContactInformationType[CaseContactInformationType["UNKNOWN"] = 0] = "UNKNOWN";
    CaseContactInformationType[CaseContactInformationType["PHONE"] = 1] = "PHONE";
    CaseContactInformationType[CaseContactInformationType["MOBILE"] = 2] = "MOBILE";
    CaseContactInformationType[CaseContactInformationType["FAX"] = 3] = "FAX";
    CaseContactInformationType[CaseContactInformationType["WEB"] = 4] = "WEB";
    CaseContactInformationType[CaseContactInformationType["EMAIL"] = 5] = "EMAIL";
    CaseContactInformationType[CaseContactInformationType["DONOTCALL"] = 6] = "DONOTCALL";
    CaseContactInformationType[CaseContactInformationType["FACEBOOK"] = 7] = "FACEBOOK";
    CaseContactInformationType[CaseContactInformationType["TWITTER"] = 8] = "TWITTER";
    CaseContactInformationType[CaseContactInformationType["LINKEDIN"] = 9] = "LINKEDIN";
    CaseContactInformationType[CaseContactInformationType["GOOGLEPLUS"] = 10] = "GOOGLEPLUS";
    CaseContactInformationType[CaseContactInformationType["YOUTUBE"] = 11] = "YOUTUBE";
    CaseContactInformationType[CaseContactInformationType["Text"] = 12] = "Text";
    CaseContactInformationType[CaseContactInformationType["Mail"] = 13] = "Mail";
    CaseContactInformationType[CaseContactInformationType["MANGO"] = 14] = "MANGO";
})(CaseContactInformationType || (CaseContactInformationType = {}));
//# sourceMappingURL=caseContactInformationType.js.map